import { useContent, useWa, rich } from "@/lib/content";
import { Reveal, SectionTitle, WhatsIcon } from "./Primitives";

export const Productos = () => {
  const { PRODUCTS, TEXTS: T } = useContent();
  const waLink = useWa();
  const list = Array.isArray(PRODUCTS) ? PRODUCTS : [];
  if (!list.length) return null;

  return (
    <section id="productos" data-testid="productos-section" className="bg-roast py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <SectionTitle eyebrow={T.prod_eyebrow} title={rich(T.prod_title)} de={T.prod_de} testid="productos-title" />
          <Reveal>
            <p className="max-w-sm font-sans text-sand">{T.prod_sub}</p>
          </Reveal>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-3 lg:grid-cols-4">
          {list.map((p, i) => (
            <Reveal key={`${p.name}-${i}`} delay={i * 0.08} className={i % 2 ? "lg:mt-14" : ""}>
              <article data-testid={`product-card-${p.key || i}`} className="group">
                <div className="relative overflow-hidden rounded-t-full border border-gold/20">
                  <img src={p.img} alt={p.name} loading="lazy" className="aspect-[3/4] w-full object-cover transition-transform duration-[1.2s] group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-espresso/70 via-transparent to-transparent" />
                  <p className="absolute bottom-3 left-0 right-0 text-center font-display text-sm italic text-gold-light sm:bottom-5 sm:text-lg">{p.de}</p>
                </div>
                <h3 className="mt-3 font-display text-xl text-cream sm:mt-5 sm:text-3xl">{p.name}</h3>
                <p className="mt-1 font-sans text-[13px] leading-relaxed text-sand sm:mt-2 sm:text-sm">{p.text}</p>
                <a
                  data-testid={`product-whatsapp-${p.key || i}`}
                  href={waLink("wa_msg_prod", { producto: p.name.toLowerCase() })}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-flex items-center gap-1.5 font-sans text-xs uppercase tracking-[0.15em] text-gold transition-colors hover:text-cream sm:mt-4 sm:gap-2 sm:text-xs sm:tracking-[0.2em]"
                >
                  <WhatsIcon className="h-3.5 w-3.5" /> {T.btn_prod_wa}
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
